// extracted by mini-css-extract-plugin
export default {"cls1":"Gi58TsKH0DVr0FXJRuZn","cls2":"xhFPnfShfcrpY2SGB7i7 Gi58TsKH0DVr0FXJRuZn","isTabletDown":"OJWQfXbU1ipobJFWxnDA","isPhone":"x5NTPdMWOCmyUP5mZqMa"};